module.exports = __webpack_public_path__ + "img/SK36869376.2901de52.png";